import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AixueModalMask from '@/components/AixueModalMask/index';
import Router from '@/router';
import '@/styles/main.scss';

// 导入antd样式
import 'antd/dist/reset.css';
// 导入UnoCSS样式
import 'virtual:uno.css';

import { initAnalytics } from '@/utils/analytics';

initAnalytics();

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <Router />
      <React.Suspense fallback={null}>{AixueModalMask && <AixueModalMask />}</React.Suspense>
    </BrowserRouter>
  </React.StrictMode>,
);
